import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';

const RedeemBranchModal = ({ show, handleClose, branches, onRedeem, loading }) => {
    const [selectedBranch, setSelectedBranch] = useState('');
    const [error, setError] = useState('');

    const handleRedeemClick = () => {
        if (!selectedBranch) {
            setError('Please select the branch where the redemption occurred.');
            return;
        }
        setError('');
        onRedeem(selectedBranch);
    };

    const handleSelectChange = (e) => {
        setSelectedBranch(e.target.value);
        setError('');
    };

    const handleModalClose = () => {
        setSelectedBranch('');
        setError('');
        handleClose();
    };

    return (
        <Modal centered show={show} onHide={handleModalClose} size="md">
            <Modal.Header closeButton>
                <Modal.Title>Select Redeemed Branch</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-5">
                <Form.Group>
                    <Form.Label>Select the branch where the redemption occurred:</Form.Label>
                    <Form.Select value={selectedBranch} onChange={handleSelectChange}>
                        <option value="">Select Redeemed Branch</option>
                        {Array.isArray(branches) &&
                            branches.map((branch) => (
                                <option key={branch._id} value={branch._id}>
                                    {branch.name}
                                </option>
                            ))}
                    </Form.Select>
                    {error && <div className="text-danger mt-2">{error}</div>}
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-end">
                <Button variant="secondary" onClick={handleModalClose} disabled={loading}>
                    Cancel
                </Button>
                <Button style={{ background: '#198754', padding: '9px' }} onClick={handleRedeemClick} disabled={loading}>
                    {loading ? 'Processing...' : 'Redeem'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RedeemBranchModal;
